import { FirmActiveWork } from '../../../types/firm';
import { Workpaper } from '../../../types/workpaper';
import OverdueWorkpapers from './OverdueWorkpapers';
import PieChartInsights from './PieChartInsights';
import Statistics from './Statistics';

type ActiveWorkProps = {
    activeWork: FirmActiveWork;
    overdueWorkpapers: { total: number; topResults: Workpaper[] };
};

function ActiveWork({ activeWork, overdueWorkpapers }: ActiveWorkProps): JSX.Element {
    return (
        <div className="grid gap-y-4">
            <h1 className="text-lg font-bold text-gray-800 dark:text-white">Current work</h1>
            <Statistics activeWork={activeWork} />
            <section className="grid lg:grid-cols-2 gap-4">
                <OverdueWorkpapers overdueWorkpapers={overdueWorkpapers} />
                <PieChartInsights activeWork={activeWork} />
            </section>
        </div>
    );
}

export default ActiveWork;
